module.exports = __webpack_public_path__ + "static/media/group.e866b014.svg";